import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { getFromLocalStorage } from '../utils/localStorage';

// A route that only allows creator/creator_pro users
const CreatorRoute = ({ children }) => {
  const [isChecking, setIsChecking] = useState(true);
  const [isAuthorized, setIsAuthorized] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const checkAuth = () => {
      try {
        const token = getFromLocalStorage('token');
        const isLoggedIn = (token && token.trim() !== '');
        
        if (!isLoggedIn) {
          // Redirect to login with return URL
          const nextUrl = `/login?next=${encodeURIComponent(location.pathname)}`;
          navigate(nextUrl, { replace: true, state: { from: location } });
          return false;
        }

        // Check user role
        const userRaw = localStorage.getItem('user');
        if (!userRaw) return false;
        
        const user = typeof userRaw === 'string' ? JSON.parse(userRaw) : userRaw;
        const userType = user?.user_type || user?.role || 'user';
        const membershipPlan = user?.membershipPlan || 'free';
        
        const isCreator = userType === 'creator' || user.isCreator === true;
        const isCreatorPro = isCreator && membershipPlan === 'pro';
        
        if (!isCreator && !isCreatorPro) {
          // Not a creator, redirect to home
          navigate('/', { replace: true });
          return false;
        }
        
        return true;
      } catch (error) {
        console.error('Error in CreatorRoute:', error);
        return false;
      }
    };

    const authorized = checkAuth();
    setIsAuthorized(authorized);
    setIsChecking(false);
  }, [navigate, location]);

  if (isChecking) return null; // Avoid flashing content during check
  if (!isAuthorized) return null; // Redirected

  return children;
};

export default CreatorRoute;
